import {get} from "lodash"

export const toString = (reward, property) => {
  if (get(reward, `${[property]}.length`, 0) === 0) {
    return ""
  }

  return `- ${reward[property].join("\n- ")}`
}

export const toArray = (value = "") => {
  return value ? value.replace(/\n/g, "").split("- ").slice(1) : []
}
